import { Component, OnInit } from "@angular/core";
import {
  faHome,
  faSadTear,
  faSatelliteDish,
  faSignInAlt,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";
import { AutenticarService } from "../servicios/autenticar.service";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { CentralService } from "../servicios/central.service";

@Component({
  selector: "app-cabecera",
  templateUrl: "./cabecera.component.html",
  styleUrls: ["./cabecera.component.css"],
})
export class CabeceraComponent implements OnInit {
  icoCasa = faHome;
  icoEntr = faSignInAlt;
  icoSale = faSignOutAlt;
  icoinfo = faSatelliteDish;
  isCollapsed = true;
  isLogged: boolean = false;
  nomUsu: string = "";
  constructor(
    private srvCentral: CentralService,
    private srvAutentica: AutenticarService,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.srvAutentica.isAuthenticated.subscribe((val) => (this.isLogged = val));
  }

  cierre(): void {
    this.srvAutentica.logout();
  }

  cierraSesion(): void {
    this.srvAutentica.logout();
    this.router.navigate(["/login"]);
  }
  volver(): void {
    this.location.back();
  }

  inicio(): void {
    if (this.srvAutentica.isAdmin()) {
      this.router.navigate(["/adminPanel"]);
    } else {
      this.router.navigate(["/portada"]);
    }
  }

  getNombreUsuario(): string {
    this.nomUsu = this.srvCentral.datosIden.UsuNom;
    return this.nomUsu;
  }
}
